export interface Query {
    method: string,
    name?: string,
    value?: any
}

export class QueryWrapper {

    querys: Query[] = [];

    /**
     * 创建
     * @returns 
     */
    public static create() {
        return new QueryWrapper();
    }

    public clear() {
        this.querys = [];
    }

    /**
     * 获取查询队列
     * @returns 
     */
    public getQuerys() {
        return this.querys;
    }

    /**
     * 全部eq(或个别isNull)
     * allEq({id:1,name:"老王",age:null})--->id = 1 and name = '老王' and age is null
     * @param params 
     * @returns 
     */
    public allEq(params: any) {
        this.querys.push({ method: "allEq", value: params });
        return this;
    }

    /**
     * 等于 =
     * 例: eq("name", "老王")--->name = '老王'
     * @param name 
     * @param val 
     * @returns 
     */
    public eq(name: string, val: any) {
        this.querys.push({ method: "eq", name: name, value: val });
        return this;
    }

    /**
     * 不等于 <>
     * 例: ne("name", "老王")--->name <> '老王'
     * @param name 
     * @param val 
     * @returns 
     */
    public ne(name: string, val: any) {
        this.querys.push({ method: "ne", name: name, value: val });
        return this;
    }

    /**
     * 大于 >
     * gt("age", 18)--->age > 18
     * @param name 
     * @param val 
     * @returns 
     */
    public gt(name: string, val: any) {
        this.querys.push({ method: "gt", name: name, value: val });
        return this;
    }

    /**
     * 大于等于 >=
     * 例: ge("age", 18)--->age >= 18
     * @param name 
     * @param val 
     * @returns 
     */
    public ge(name: string, val: any) {
        this.querys.push({ method: "ge", name: name, value: val });
        return this;
    }

    /**
     * 小于 <
     * 例: lt("age", 18)--->age < 18
     * @param name 
     * @param val 
     * @returns 
     */
    public lt(name: string, val: any) {
        this.querys.push({ method: "lt", name: name, value: val });
        return this;
    }

    /**
     * 小于等于 <=
     * 例: le("age", 18)--->age <= 18
     * @param name 
     * @param val 
     * @returns 
     */
    public le(name: string, val: any) {
        this.querys.push({ method: "le", name: name, value: val });
        return this;
    }

    /**
     * BETWEEN 值1 AND 值2
     * 例: between("age", 18, 30)--->age between 18 and 30
     * @param name 
     * @param val1 
     * @param val2 
     * @returns 
     */
    public between(name: string, val1: any, val2: any) {
        this.querys.push({ method: "between", name: name, value: [val1, val2] });
        return this;
    }

    /**
     * NOT BETWEEN 值1 AND 值2
     * 例: notBetween("age", 18, 30)--->age not between 18 and 30
     * @param name 
     * @param val1 
     * @param val2 
     * @returns 
     */
    public notBetween(name: string, val1: any, val2: any) {
        this.querys.push({ method: "notBetween", name: name, value: [val1, val2] });
        return this;
    }

    /**
     * LIKE '%值%'
     * 例: like("name", "王")--->name like '%王%'
     * @param name 
     * @param val 
     * @returns 
     */
    public like(name: string, val: any) {
        this.querys.push({ method: "like", name: name, value: val });
        return this;
    }

    /**
     * NOT LIKE '%值%'
     * 例: notLike("name", "王")--->name not like '%王%'
     * @param name 
     * @param val 
     * @returns 
     */
    public notLike(name: string, val: any) {
        this.querys.push({ method: "notLike", name: name, value: val });
        return this;
    }

    /**
     * LIKE '%值'
     * 例: likeLeft("name", "王")--->name like '%王'
     * @param name 
     * @param val 
     * @returns 
     */
    public likeLeft(name: string, val: any) {
        this.querys.push({ method: "likeLeft", name: name, value: val });
        return this;
    }

    /**
     * LIKE '值%'
     * 例: likeRight("name", "王")--->name like '王%'
     * @param name 
     * @param val 
     * @returns 
     */
    public likeRight(name: string, val: any) {
        this.querys.push({ method: "likeRight", name: name, value: val });
        return this;
    }

    /**
     * 字段 IS NULL
     * 例: isNull("name")--->name is null
     * @param name 
     * @returns 
     */
    public isNull(name: string) {
        this.querys.push({ method: "isNull", name: name });
        return this;
    }

    /**
     * 字段 IS NOT NULL
     * 例: isNotNull("name")--->name is not null
     * @param name 
     * @returns 
     */
    public isNotNull(name: string) {
        this.querys.push({ method: "isNotNull", name: name });
        return this;
    }

    /**
     * 字段 IN (value.get(0), value.get(1), ...)
     * in("age",[1,2,3])--->age in (1,2,3)
     * @param name 
     * @param val 
     * @returns 
     */
    public in(name: string, val: any[]) {
        this.querys.push({ method: "in", name: name, value: val });
        return this;
    }

    /**
     * 字段 NOT IN (value.get(0), value.get(1), ...)
     * 例: notIn("age",[1,2,3])--->age not in (1,2,3)
     * @param name 
     * @param val 
     * @returns 
     */
    public notIn(name: string, val: any[]) {
        this.querys.push({ method: "notIn", name: name, value: val });
        return this;
    }

    /**
     * 分组：GROUP BY 字段, ...
     * 例: groupBy(["id", "name"])--->group by id,name
     * @param name 
     * @param val 
     * @returns 
     */
    public groupBy(val: string[]) {
        this.querys.push({ method: "groupBy", name: "", value: val });
        return this;
    }

    /**
     * 排序：ORDER BY 字段, ...
     * 例: orderBy(["id", "name"], true)--->order by id ASC,name ASC
     * @param val 
     * @param isAsc 
     * @returns 
     */
    public orderBy(val: string[], isAsc: boolean = true) {
        this.querys.push({ method: isAsc ? "orderByAsc" : "orderByDesc", name: "", value: val });
        return this;
    }

    /**
     * 根据字段自定义值排序
     * 例: orderByField("status","5, 2, 3, 4, 1" ) ---> ORDER BY FIELD(status, 5, 2, 3, 4, 1);
     * @param filed 字段名
     * @param value 排序值
     */
    public orderByField(filed: string, value: string) {
        this.querys.push({ method: "orderByField", name: filed, value: value });
        return this;
    }

    /**
     * 拼接 OR
     * 例: eq("id",1).or().eq("name","老王")--->id = 1 or name = '老王'
     * @returns 
     */
    public or2() {
        this.querys.push({ method: "or" });
        return this;
    }

    /**
     * OR 嵌套
     * 例: or(i -> i.eq("name", "李白").ne("status", "活着"))--->or (name = '李白' and status <> '活着')
     * @param consumer 
     */
    public or(consumer: (queryWrapper: QueryWrapper) => void) {
        const queryWrapper: QueryWrapper = new QueryWrapper();
        consumer(queryWrapper);
        this.querys.push({ method: "or", value: queryWrapper.getQuerys() });
        return this;
    }

    /**
     * AND 嵌套
     * 例: and(i -> i.eq("name", "李白").ne("status", "活着"))--->and (name = '李白' and status <> '活着')
     * @param consumer 
     * @returns 
     */
    public and(consumer: (queryWrapper: QueryWrapper) => void) {
        const queryWrapper: QueryWrapper = new QueryWrapper();
        consumer(queryWrapper);
        this.querys.push({ method: "and", value: queryWrapper.getQuerys() });
        return this;
    }

    /**
     * 正常嵌套 不带 AND 或者 OR
     * 例: nested(i -> i.eq("name", "李白").ne("status", "活着"))--->(name = '李白' and status <> '活着')
     * @param consumer 
     * @returns 
     */
    public nested(consumer: (queryWrapper: QueryWrapper) => void) {
        const queryWrapper: QueryWrapper = new QueryWrapper();
        consumer(queryWrapper);
        this.querys.push({ method: "nested", value: queryWrapper.getQuerys() });
        return this;
    }

    /**
     * 设置查询字段
     * 例: select(["id", "name", "age"])
     * @param fields 
     * @returns 
     */
    public select(fields: string[]) {
        this.querys.push({ method: 'select', value: fields });
        return this;
    }

}